module.exports = __webpack_public_path__ + "img/max_deposit_ntd_mobile2.20b7db8d.png";